import script from "./CartWidget.vue?vue&type=script&lang=ts&setup=true"
export * from "./CartWidget.vue?vue&type=script&lang=ts&setup=true"

import "./CartWidget.vue?vue&type=style&index=0&id=5c902f35&lang=scss"

const __exports__ = script;

export default __exports__